import 'reflect-metadata'
import { injectable } from 'inversify-props'
import type { MonitoramentoBancoServiceAdapter } from '@/usecases/monitoramento-banco/adapter'
import { findStatus } from '@/api/monitoramento-banco'

@injectable()
export class MonitoramentoBancoService implements MonitoramentoBancoServiceAdapter {
	findStatus = () => findStatus()
}
